$(function() {
	// モーダルウィンドウ（+ボタン）
	var sharebtn = $('.ProductMeta__ShareButtons');
	$('.Product__Info .Container').append(sharebtn);
	
	// モーダルウィンドウ（+ボタン）
	for (var i = 0; i < $('.item-data .op .list').length; i++) {
		var child = 1 + i;
		var oplist = $(".item-data .op .list:nth-child(" + child + ") .item-inner");
		var oplistno = $(oplist).addClass("no" + child);
		$('body').append(oplistno);
	};
	
	// 商品詳細情報移動
	var detailbox = $('#detail-box');
	$('#shopify-section-product-recommendations').before(detailbox);
    $('#detail-box').css({display:'block'});
    
    // 税込移動
    var taxdata = $('.ProductMeta .ProductMeta__TaxNotice');
    $('.features--heading-uppercase .Heading .ProductMeta__Price').after(taxdata);
    
    $('.item-d-photo-btn').click(function(){

		// ページ背景スクロール不可
		/*var scrollY = $(window).scrollTop(); //現在のスクロール位置
		$('body').css({'position': 'fixed','width': '100%', 'top': '-' + scrollY + 'px','overflow-y': 'scroll'});*/
		
         // スクロールバーの横幅を取得
        var scrollsize = $(window).width() - $('body').prop('clientWidth');

        // html、bodyを固定（overflow:hiddenにする）
        $('html').addClass('lock');

        // オーバーレイ用の要素を追加
        $('body').append('<div class="modal-overlay"></div>');

        // オーバーレイをフェードイン
        $('.modal-overlay').fadeIn(200);

        // モーダルコンテンツのCLASSを取得
        var modal = '.' + $(this).attr('data-target');

         // モーダルコンテンツを囲む要素を追加
        /*$(modal).wrap("<div class='modal-wrap'></div>");

        // モーダルコンテンツを囲む要素を表示
        $('.modal-wrap').show();*/

        // モーダルコンテンツの表示位置を設定
        modalResize();

        $(modal).fadeIn(200);
		
        // モーダルコンテンツをクリックした時はフェードアウトしない
        $(modal).click(function(e){
            e.stopPropagation();
        });

        // 「.modal-overlay」あるいは「.modal-close」あるいは「.modal-content .op-list」をクリック
        $('.modal-close,.modal-overlay').off().click(function(){
			
			// ページ背景スクロール不可解除
			/*var scrollY = $(window).scrollTop(); //現在のスクロール位置
			$('body').css({'position': 'initial','width': 'auto' ,'top': 'initial'});
			$(window).scrollTop(scrollY);*/
			
            // モーダルコンテンツとオーバーレイをフェードアウト
            $(modal).fadeOut(200);
            $('.modal-overlay').fadeOut(200,function(){
                // html、bodyの固定解除
                $('html, body').removeClass('lock');
                // オーバーレイを削除
                $('.modal-overlay').remove();
                // モーダルコンテンツを囲む要素を削除
                $(modal).unwrap("<div class='item-inner'></div>");
           });
        });

        // リサイズしたら表示位置を再取得
        $(window).on('resize', function(){
            modalResize();
        });

        // モーダルコンテンツの表示位置を設定する関数
        function modalResize(){
            // ウィンドウの横幅、高さを取得
            var w = $(window).width();
            var h = $(window).height();

            // モーダルコンテンツの横幅、高さを取得
            var mw = $(modal).outerWidth(true);
            var mh = $(modal).outerHeight(true);

            // モーダルコンテンツの表示位置を設定
            if ((mh > h) && (mw > w)) {
                $(modal).css({'left': 0 + 'px','top': 0 + 'px'});
            } else if ((mh > h) && (mw < w)) {
                var x = (w - scrollsize - mw) / 2;
                $(modal).css({'left': x + 'px','top': 0 + 'px'});
            } else if ((mh < h) && (mw > w)) {
                var y = (h - scrollsize - mh) / 2;
                $(modal).css({'left': 0 + 'px','top': y + 'px'});
            } else {
                var x = (w - mw) / 2;
                var y = (h - mh) / 2;
                $(modal).css({'left': x + 'px','top': y + 'px'});
            }
        }

    });
	
});